import dynamic from 'next/dynamic';
import { useRef, useState } from 'react';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import { useLocationState } from '../context/location';
import Input from './Input';
import Textarea from './Textarea';
import css from '../styles/modules/SplitterFeed.module.scss';

const shakeEl = (el) => {
  el.animate(
    [
      { transform: 'translate3d(-2px, 0, 0)' },
      { transform: 'translate3d(2px, 0, 0)' },
      { transform: 'translate3d(-5px, 0, 0)' },
      { transform: 'translate3d(5px, 0, 0)' },
      { transform: 'translate3d(0, 0, 0)' }
    ],
    200
  );
};

const Modal = dynamic(() => import('./Modal'));

const SplitterFeed = ({ title, subtitle }) => {
  /** STATES */
  const locationState = useLocationState();
  const [isModalFeedbackVisible, setIsModalFeedbackVisible] = useState(false);
  const [isModalSuccessVisible, setIsModalSuccessVisible] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientFeed, setClientFeed] = useState('');
  const [clientMail, setClientMail] = useState('');
  const [clientComment, setClientComment] = useState('');
  const clientNameId = useRef();
  const clientPhoneId = useRef();
  const clientMailId = useRef();
  const clientFeedId = useRef();
  const inputParentId = useRef(null);
  const inputId = useRef();

  /** HANDLERS */
  const handleFeedbackClick = () => {
    //console.log(clientFeed.slice(0,8) );
    if (clientFeed.slice(0,8) === 'https://' || clientFeed.slice(0,7) === 'http://')
      setIsModalFeedbackVisible(true);
    else
      shakeEl(inputParentId.current);
  };
  const handleFormSubmit = () => {
    clientNameId.current.setError(clientName.length < 3);
    clientPhoneId.current.setError(clientPhone.length !== 11);
    clientFeedId.current.setError(clientFeed.length < 15);
    //console.log(clientFeed.length);

    if (clientName.length >= 3 && clientPhone.length === 11 && clientFeed.length >= 15) {
      setIsModalFeedbackVisible(false);
      setIsModalSuccessVisible(true);

      axios.post(process.env.NEXT_PUBLIC_API + '/client', {
        clientName,
        clientPhone,
        clientMail,
        clientFeed,
        clientComment,
        pathName: window.location.pathname,
        whatComponent: 'SplitterFeed',
        location: locationState.region,
        platform: 'web'
      });

      inputId.current.value = '';
    }
  };

  return (
    <>
      <Modal
        title="Обратная связь"
        visibility={isModalSuccessVisible}
        onClose={() => setIsModalSuccessVisible(false)}
      >
        <div style={{ marginBottom: 18 }}>
          Спасибо за вашу заявку. В ближайшее время мы подключим фид и Ваши обьявления появятся на сайте
        </div>
      </Modal>
      <Modal
        title="Подключить фид"
        button="Подключить"
        action={handleFormSubmit}
        visibility={isModalFeedbackVisible}
        onClose={() => setIsModalFeedbackVisible(false)}
      >
        <div style={{ marginBottom: 18 }}>
          Мы принимаем XML файлы с объявлениями по недвижимости в формате Яндекс.Недвижимости доступные по ссылке
        </div>
        <Input
          title="Название компании / агентства"
          inputs={[
            {
              placeholder: 'АН Солнышко',
              value: clientName,
              type: 'text'
            }
          ]}
          isWrappedStyle
          ref={clientNameId}
          onChange={(v) => setClientName(v[0])}
        />
        <Input
          title="E-mail"
          inputs={[
            {
              placeholder: 'vasya@yandex.ru',
              value: clientMail,
              type: 'text'
            }
          ]}
          isWrappedStyle
          ref={clientMailId}
          onChange={(v) => setClientMail(v[0])}
        />
        <Input
          title="Телефон"
          inputs={[
            {
              placeholder: locationState.phone,
              value: clientPhone,
              mask: 'phone',
              type: 'tel'
            }
          ]}
          isWrappedStyle
          ref={clientPhoneId}
          onChange={(v) => setClientPhone(v[0])}
        />
        <Input
          title="Ссылка на фид в формате Яндекс.Недвижимости"
          inputs={[
            {
              placeholder: 'https://',
              value: clientFeed,
              type: 'text'
            }
          ]}
          isWrappedStyle
          ref={clientFeedId}
          onChange={(v) => setClientFeed(v[0])}
        />
        <Textarea
          title="Коммментарий"
          placeholder="Например, «Подключите фид как можно быстрее»"
          autoHeight
          isWrappedStyle
          onChange={(v) => setClientComment(v)}
        />
        <div style={{ textAlign: 'center', opacity: 0.8, fontSize: 14, margin: '18px 0' }}>
          Вы соглашаетесь с{' '}
          <a href="/faq/policy" target="_blank">
            политикой конфиденциальности
          </a>{' '}
          при отправке данной формы к нам в работу
        </div>
      </Modal>
      <section className="block fill clear">
        <div className={['fixed', css.splitter].join(' ')}>
          <div className={css.text}>
            <h2 className={css.title}>{title}</h2>
            <div className={css.subtitle}>{subtitle}</div>
          </div>
          <div className={css.actions}>
            <div className={css.input} ref={inputParentId}>
              <Input
                className={css.inputZone}
                inputs={[
                  {
                    placeholder: 'https://',
                    value: clientFeed,
                    type: 'text'
                  }
                ]}
                isWrappedStyle
                ref={inputId}
                onChange={(v) => setClientFeed(v[0])}
              />
              <button
                className={css.inputButton}
                type="button"
                aria-label="Подключить"
                onClick={handleFeedbackClick}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="22" y1="2" x2="11" y2="13" />
                  <polygon points="22 2 15 22 11 13 2 9 22 2" />
                </svg>
              </button>
            </div>
            <div className={css.help}>Ссылка на фид в формате Яндекс.Недвижимости</div>
          </div>
        </div>
      </section>
    </>
  );
};

SplitterFeed.defaultProps = {
  title: 'Подключить xml выгрузку',
  subtitle: 'Подключаем агентства недвижимости, риэлторов, застройщиков, бизнес-центры и т.п.'
};

export default SplitterFeed;
